var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMandarin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st83{fill:#FFFFFF;}\n\t.st82{fill:none;stroke:#010101;stroke-width:2;stroke-miterlimit:10;}\n\t.st81{fill:#FFFFFF;stroke:#010101;stroke-width:2;stroke-miterlimit:10;}\n\t.st80{fill:#FFFFFF;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3;}\n\t.st79{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st78{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:3.0366,3.0366;}\n\t.st77{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:2.9808,2.9808;}\n\t.st76{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:2.9809,2.9809;}\n\t.st75{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:2.9899,2.9899;}\n\t.st74{fill:none;stroke:#010101;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:2.9742,2.9742;}\n\t.st73{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st83",
    x1: 108.97,
    y1: 204.15,
    x2: 51.09,
    y2: 225.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st82",
    x1: 108.97,
    y1: 204.15,
    x2: 51.09,
    y2: 225.16
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st83",
    x1: 314.03,
    y1: 204.15,
    x2: 371.91,
    y2: 225.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st82",
    x1: 314.03,
    y1: 204.15,
    x2: 371.91,
    y2: 225.16
  })), /*#__PURE__*/React.createElement("line", {
    className: "st81",
    x1: 194.91,
    y1: 266.97,
    x2: 193.91,
    y2: 401.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st80",
    x1: 197.31,
    y1: 266.97,
    x2: 196.31,
    y2: 401.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M210.92,235.65c0.01,0,0.02,0,0.02,0c8.99,0,16.28,7.29,16.28,16.27v19.39c-0.67,0.01-15.62,0.01-16.31,0.01 c-39.27,0-73.36-14.88-90.37-36.69c-7.38-9.45-11.55-20.19-11.55-31.59v-35.67c0,0.97,0.03,1.94,0.1,2.89 c-0.01,0.01-0.01,0.02,0,0.03c0.37,5.92,1.87,11.66,4.35,17.09c-0.01,0.01,0.01,0.02,0.01,0.02c1.84,4.02,4.21,7.89,7.08,11.56 C137.56,220.77,171.65,235.65,210.92,235.65z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M210.92,268.26c-37.17,0-70.88-13.61-87.96-35.51c-7.23-9.26-10.9-19.26-10.9-29.71v-11.57 c1.71,3.26,3.75,6.4,6.08,9.38c18.21,23.35,53.76,37.86,92.78,37.86c7.32,0,13.25,5.93,13.25,13.22v16.33 C220.65,268.26,214.84,268.26,210.92,268.26z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M112.06,192.97v-1.5c0.23,0.44,0.47,0.88,0.71,1.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M114.32,195.4c1.17,1.87,2.44,3.69,3.82,5.45c18.21,23.35,53.76,37.86,92.78,37.86 c7.32,0,13.25,5.93,13.25,13.22v13.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M224.17,266.76v1.5c-0.46,0-0.96,0-1.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M219.69,268.26c-2.97,0-6.26,0-8.77,0c-37.17,0-70.88-13.61-87.96-35.51c-7.23-9.26-10.9-19.26-10.9-29.71 v-8.58"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M210.92,234.63c-0.01,0-0.02,0-0.02,0c-8.99,0-16.28,7.29-16.28,16.27v19.39c0.67,0.01,15.62,0.01,16.31,0.01 c39.27,0,73.36-14.88,90.37-36.69c7.38-9.45,11.55-20.19,11.55-31.59v-35.67c0,0.97-0.03,1.94-0.1,2.89c0.01,0.01,0.01,0.02,0,0.03 c-0.37,5.92-1.87,11.66-4.35,17.09c0.01,0.01-0.01,0.02-0.01,0.02c-1.84,4.02-4.21,7.89-7.08,11.56 C284.28,219.75,250.19,234.63,210.92,234.63z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M197.67,267.24V250.9c0-7.29,5.93-13.22,13.22-13.22c39.04,0,74.59-14.51,92.81-37.87 c2.33-2.97,4.37-6.12,6.08-9.37v11.57c0,10.46-3.67,20.45-10.9,29.71c-17.08,21.91-50.79,35.51-87.96,35.51 C207,267.24,201.18,267.24,197.67,267.24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M199.17,267.24c-0.53,0-1.03,0-1.5,0v-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st78",
    d: "M197.67,262.7v-11.8c0-7.29,5.93-13.22,13.22-13.22c39.04,0,74.59-14.51,92.81-37.87 c1.69-2.16,3.24-4.42,4.61-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M309.06,191.76c0.24-0.44,0.48-0.88,0.71-1.32v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M309.78,194.93v7.09c0,10.46-3.67,20.45-10.9,29.71c-17.08,21.91-50.79,35.51-87.96,35.51 c-2.94,0-6.96,0-10.26,0"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M312.73,167.2c0.01,0.01,0.01,0.02,0,0.03c-0.37,5.92-1.87,11.66-4.35,17.09c0.01,0.01-0.01,0.02-0.01,0.02 l-0.18,0.4c-12.95-20.7-51.6-35.72-97.27-35.72s-84.32,15.02-97.27,35.72l-0.18-0.4c0,0-0.02-0.01-0.01-0.02 c-2.49-5.43-3.98-11.17-4.35-17.09c-0.01-0.01-0.01-0.02,0-0.03c2.3-27.12,47-48.76,101.81-48.76S310.43,140.08,312.73,167.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M307.41,178.48c-16.29-19.64-53.94-32.52-96.5-32.52c-42.56,0-80.21,12.88-96.5,32.52 c-1.24-3.68-2-7.44-2.25-11.23c2.38-25.25,46.58-45.75,98.75-45.75c52.16,0,96.37,20.5,98.75,45.75 C309.41,171.04,308.66,174.8,307.41,178.48z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M307.87,177.06c-0.14,0.48-0.3,0.95-0.46,1.43c-0.32-0.38-0.64-0.76-0.97-1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M304.4,175.17c-17.62-17.76-53.37-29.2-93.48-29.2c-40.91,0-77.29,11.9-94.51,30.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st79",
    d: "M115.39,177.35c-0.33,0.38-0.66,0.76-0.97,1.14c-0.16-0.48-0.31-0.95-0.46-1.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M113.2,174.18c-0.53-2.29-0.87-4.6-1.03-6.93c2.38-25.25,46.58-45.75,98.75-45.75 c52.16,0,96.37,20.5,98.75,45.75c-0.19,2.81-0.65,5.61-1.39,8.37"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "st73",
    cx: 209.63,
    cy: 254.96,
    r: 8.38
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandarin);
export default __webpack_public_path__ + "static/media/MANDARIN.322df11fed75670fd55d0fc2f45d9433.svg";
export { ForwardRef as ReactComponent };